import { gql } from '@apollo/client';

export default gql`
  query priorityCategories {
    priorityCategories
  }
`;
